import { post } from '@/utils/http/http'
import { HOMEMINIURI } from '@/utils/http/baseUrl'

export default {
  postPrivateDomainTrafficDetail: params =>
    post(`/marketing/wx/v1/public/private_domain/drainage/detail`, params),
  postSmsPrivateDomainTrafficDetail: params =>
    post(`${HOMEMINIURI}/api/SMSTask/SmsMembers`, params)
}
